import { render, staticRenderFns } from "./myMaterial.vue?vue&type=template&id=a6b8475e&scoped=true&"
import script from "./myMaterial.vue?vue&type=script&lang=js&"
export * from "./myMaterial.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/material/myMaterial.less?vue&type=style&index=0&id=a6b8475e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b8475e",
  null
  
)

component.options.__file = "myMaterial.vue"
export default component.exports